function noop() {}

export { noop };